// Auto-generated icon module
const svg = `<svg width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
  <path d="M17.9,13.2l-5.4,5.3V3h-1v15.5l-5.4-5.3l-0.7,0.7l6.6,6.5l6.6-6.5L17.9,13.2z" />
</svg>
`;

export { svg as default };
//# sourceMappingURL=it-arrow-down-CKDXUv8J.js.map
